// extracted by mini-css-extract-plugin
export default {"app":"fulllayout_app__UMxUg","content":"fulllayout_content__j3iqg"};